import { type GrafitUserWithRoles, isGrafitEmail, type UserData, type UserRole } from "../domain/user/user.ts";

interface UserAuthType {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  email: string;
  emailVerified: boolean;
  name: string;
  image?: string | null | undefined;
  banned?: boolean | null | undefined;
  role?: string | null | undefined;
  banReason?: string | null | undefined;
  banExpires?: Date | null | undefined;
}

export const mapAuthUserToGrafitUser = ({
  user,
  roles,
  data,
}: {
  user: UserAuthType;
  roles: UserRole[];
  data?: Omit<UserData, "tenderRefCount" | "tenderRefYear">;
}): GrafitUserWithRoles => ({
  id: user.id,
  imageUrl: user.image ?? undefined,
  email: user.email,
  fullName: user.name,
  roles,
  isGrafitAdmin: isGrafitEmail(user.email),
  phoneNumber: data?.phoneNumber ?? "",
  jobTitle: data?.jobTitle ?? "",
  trigram: data?.trigram ?? "",
});
